module.exports = __webpack_public_path__ + "img/2.940e592f.png";